import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "components/documents/documents-container.scss";
import { Inbox } from "components/documents/inbox";
import { getFiltersFromUrl } from "utils/get-filters-from-url";
import { setFlashMessageAction } from "actions/app-actions";
import { startDeleteCustomTabModeAction } from "actions/custom-tabs-actions";
import { trackPageAction } from "actions/shared/tracking-actions";
import {
  deselectDocumentsAction,
  endBatchCategoriesModeAction,
  endBatchEditModeAction,
  fetchDocumentsAction,
  setPaginationLimitAction,
  nextPageAction,
  previousPageAction,
  setEditColumnsVisibilityAction,
  setTrashDocumentVisibilityAction,
  selectDocumentsAction,
  startBatchCategoriesModeAction,
  startBatchEditModeAction,
  submitBatchAssignCategoriesAction,
  submitBatchEditAction,
  toggleColumnAction,
  startBatchDownloadModeAction,
  endBatchDownloadModeAction,
  submitBatchDownloadDocumentsAction,
  setChangeDocumentTypeVisibilityAction,
  setShareUrlVisibilityAction,
  documentViewedAction,
  mergeDocumentsAction,
  endMergeDocumentsModeAction,
  startMergeDocumentsModeAction,
  setTrashMultipleDocumentsVisibilityAction,
  trashMultipleDocumentsAction,
  startHamburgerModeAction,
  endHamburgerModeAction,
  startDocViewerHamburgerModeAction,
  endDocViewerHamburgerModeAction,
  startDraggabilityAction,
  endDraggabilityAction,
  startFiltersDrawerModeAction,
  endFiltersDrawerModeAction,
  deletePermanentlyAction,
  restoreDocumentsAction,
  setDeletePermanentlyVisibilityAction,
  selectMergeDocumentAction,
  deselectMergeDocumentAction,
  selectMergeFieldAction,
  deselectAllDocumentsAction,
  setDocumentViewerVisibilityAction,
  selectAllDocumentsAction,
  generateShareUrlAction,
  mapVendorRulesAction,
  showGLCodesPanelAction,
  hideGLCodesPanelAction,
  returnToDefaultColumnsAction,
  setGridWidthAction,
  startRefreshIntervalsAction,
  clearRefreshIntervalsAction,
  startExportModeAction,
  endExportModeAction,
  shiftPressedAction,
  shiftReleasedAction
} from "actions/documents-actions";
import {
  calculateGSTAction,
  saveDocumentAction,
  focusDocumentAction,
  reprocessDocumentAction,
  trashDocumentAction,
  changeDocumentTypeAction,
  submitChangeViewedSettingAction,
  unfocusDocumentAction,
  updateInlineDocumentAction,
  updateDocumentAction,
  updatePaymentTypeAction
} from "actions/update-document-actions";
import {
  paginationType,
  documentFiltersType,
  categoryType,
  routeType,
  routerType,
  customTabType
} from "custom-prop-types";
import {
  addCardNumberToFilterAction,
  addCategoryToFilterAction,
  addCurrencyToFilterAction,
  addDocumentTypeToFilterAction,
  addEndDateToFilterAction,
  addEnvelopeToFilterAction,
  addPaymentTypeToFilterAction,
  addStartDateToFilterAction,
  addVendorToFilterAction,
  clearExportTypeFilterAction,
  orderByAction,
  removeCardNumberFromFilterAction,
  removeCategoryFromFilterAction,
  removeCurrencyFromFilterAction,
  removeDocumentTypeFromFilterAction,
  removeEnvelopeFromFilterAction,
  removePaymentTypeFromFilterAction,
  removeVendorFromFilterAction,
  setExportTypeFilterAction,
  addSearchQueryToFilterAction,
  removeSearchQueryFromFilterAction,
  updateSearchQueryAction,
  setTrashViewAction,
  resetFiltersAction,
  addViewedStatusToFilterAction,
  removeViewedStatusFromFilterAction,
  setFiltersAction,
  updateTotalFilterAction,
  addTotalFilterAction,
  updateNameAction,
  addNameToFilterAction,
  removeNameFromFilterAction
} from "actions/document-filters-actions";
import {
  exportAllAction,
  exportSelectedAction,
  splitCategoriesAction,
  addIncludeRuleAction,
  addRuleErrorAction,
  linkAccountAction,
  removeIncludeRuleAction,
  setGlCodeAction,
  setViewedDocumentUrlAction
 } from "actions/exports-actions";
import { createCategoryAction } from "actions/categories-actions";
import { Loading } from "components/common/loading";

class DocumentsPage extends React.Component {
  componentWillMount() {
    const { accountId, customTabs, filters, pagination, route, router, preferredCurrency } = this.props;
    const activeFilters = getFiltersFromUrl(filters, route, router, preferredCurrency, customTabs);
    this.props.setFilters(activeFilters);
    this.props.init(accountId, activeFilters, pagination);
    this.props.splitCategories(this.props.categories);
    this.props.trackPage();
  }

  componentDidMount() {
    document.addEventListener("keydown", this.props.onShiftPressed, false);
    document.addEventListener("keyup", this.props.onShiftReleased, false);
    this.props.onStartRefreshIntervals();
  }

  componentWillUnmount() {
    this.props.resetFilters();
    this.props.onClearRefreshIntervals();
    this.props.onUnfocusDocument();
    this.props.onHideGLCodesPanel();
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return (
      <div className={ styles.container }>
        <Inbox { ...this.props } />
      </div>
    );
  }
}

DocumentsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(categoryType),
  customTabs: PropTypes.arrayOf(customTabType),
  filters: documentFiltersType.isRequired,
  init: PropTypes.func.isRequired, // (accountId: string) => void
  isLoading: PropTypes.bool.isRequired,
  onClearRefreshIntervals: PropTypes.func.isRequired,
  onHideGLCodesPanel: PropTypes.func.isRequired,
  onShiftPressed: PropTypes.func.isRequired,
  onShiftReleased: PropTypes.func.isRequired,
  onStartRefreshIntervals: PropTypes.func.isRequired,
  onUnfocusDocument: PropTypes.func.isRequired,
  pagination: paginationType.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  resetFilters: PropTypes.func.isRequired,
  route: routeType.isRequired,
  router: routerType.isRequired,
  setFilters: PropTypes.func.isRequired,
  splitCategories: PropTypes.func.isRequired,
  trackPage: PropTypes.func.isRequired
};

DocumentsPage.defaultProps = {
  categories: [],
  customTabs: [],
  endDate: null,
  exportType: null,
  startDate: null
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  accountSlug: state.app.selectedAccount.slug,
  allDocumentsTotal: state.documents.pagination.totalCount,
  cardNumbers: state.cardNumbers.cardNumbers,
  categories: state.categories.categories,
  columns: state.documents.columns,
  currencies: state.currencies.currencies,
  currentUser: state.app.user,
  customTabs: state.customTabs.customTabs,
  endDate: state.documentFilters.endDate,
  envelopes: state.envelopes.envelopes,
  exportType: state.documentFilters.exportType,
  filtersCount: state.documents.filtersCount,
  generatedShareUrl: state.documents.generatedShareUrl,
  glCodes: state.documents.glCodes,
  isChangeDocTypeVisible: state.documents.isChangeDocTypeVisible,
  isDocumentViewerVisible: state.documents.isDocumentViewerVisible,
  isBatchEditMode: state.documents.isBatchEditMode,
  isBatchCategoriesMode: state.documents.isBatchCategoriesMode,
  isBatchCategoriesLoading: state.documents.isBatchCategoriesLoading,
  isBatchDownloadLoading: state.documents.isBatchDownloadLoading,
  isBatchDownloadMode: state.documents.isBatchDownloadMode,
  isBatchEditLoading: state.documents.isBatchEditLoading,
  isFiltersDrawerMode: state.documents.isFiltersDrawerMode,
  isHamburgerMode: state.documents.isHamburgerMode,
  isDeletePermanentlyLoading: state.documents.isDeletePermanentlyLoading,
  isDeletePermanentlyVisible: state.documents.isDeletePermanentlyVisible,
  isDocViewerHamburgerMode: state.documents.isDocViewerHamburgerMode,
  isDraggable: state.documents.isDraggable,
  isExportMode: state.documents.isExportMode,
  isGLCodesLoading: state.documents.isGLCodesLoading,
  isGLCodesVisible: state.documents.isGLCodesVisible,
  isLoading: state.documents.isLoading,
  isMergeDocumentsLoading: state.documents.isMergeDocumentsLoading,
  isMergeDocumentsMode: state.documents.isMergeDocumentsMode,
  isEditColumnsVisible: state.documents.isEditColumnsVisible,
  isRestoreDocumentsLoading: state.documents.isRestoreDocumentsLoading,
  isShiftPressed: state.documents.isShiftPressed,
  isTrash: state.documentFilters.isTrash,
  isTrashMultipleDocumentsLoading: state.documents.isTrashMultipleDocumentsLoading,
  isTrashMultipleDocumentsVisible: state.documents.isTrashMultipleDocumentsVisible,
  isTrashDocumentVisible: state.documents.isTrashDocumentVisible,
  isShareUrlVisible: state.documents.isShareUrlVisible,
  filters: state.documentFilters,
  gridWidth: state.documents.gridWidth,
  lastFourDigits: state.documentFilters.lastFourDigits,
  mergeDocument: state.documents.mergeDocument,
  name: state.documentFilters.name,
  orderBy: state.documentFilters.orderBy,
  orderDirection: state.documentFilters.orderDirection,
  pagination: state.documents.pagination,
  preferredCurrency: state.accountSettings.currency,
  documents: state.documents.documents,
  searchQueryString: state.documentFilters.searchQueryString,
  selectedCardNumbers: state.documentFilters.selectedCardNumbers,
  selectedCategories: state.documentFilters.selectedCategories,
  selectedCurrencies: state.documentFilters.selectedCurrencies,
  selectedEnvelopes: state.documentFilters.selectedEnvelopes,
  selectedMergeDocumentId: state.documents.selectedMergeDocumentId,
  selectedName: state.documentFilters.selectedName,
  selectedPaymentTypes: state.documentFilters.selectedPaymentTypes,
  selectedDocumentIds: state.documents.selectedDocumentIds,
  selectedSearchQueryString: state.documentFilters.selectedSearchQueryString,
  focusedDocument: state.updateDocument,
  selectedAccount: state.app.selectedAccount,
  selectedVendors: state.documentFilters.selectedVendors,
  startDate: state.documentFilters.startDate,
  taxRate: state.accountSettings.vat,
  totalMax: state.documentFilters.totalMax,
  totalMin: state.documentFilters.totalMin,
  type: state.documentFilters.type,
  vendors: state.vendors.vendors,
  viewedStatus: state.documentFilters.viewedStatus
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId, filters, pagination) => {
    dispatch(fetchDocumentsAction(accountId, filters, pagination));
  },
  trackPage: () => dispatch(trackPageAction("Inbox page")),
  resetFilters: () => dispatch(resetFiltersAction()),
  setFilters: (filters) => dispatch(setFiltersAction(filters)),
  onAddCardNumber: (data) => dispatch(addCardNumberToFilterAction(data.key)),
  onAddCategory: (data) => dispatch(addCategoryToFilterAction(data.name)),
  onAddCurrency: (data) => dispatch(addCurrencyToFilterAction(data.key)),
  onAddDocumentType: (data) => dispatch(addDocumentTypeToFilterAction(data.key)),
  onAddEndDate: (data) => dispatch(addEndDateToFilterAction(data)),
  onAddEnvelope: (data) => dispatch(addEnvelopeToFilterAction(data.key)),
  onAddIncludeRule: (data) => dispatch(addIncludeRuleAction(data)),
  onAddNameToFilter: (name) => dispatch(addNameToFilterAction(name)),
  onAddPaymentType: (data) => dispatch(addPaymentTypeToFilterAction(data.key)),
  onAddRuleError: () => dispatch(addRuleErrorAction()),
  onAddSearchQuery: (query) => dispatch(addSearchQueryToFilterAction(query)),
  onAddStartDate: (data) => dispatch(addStartDateToFilterAction(data)),
  onAddTotalFilter: (type, value) => dispatch(addTotalFilterAction(type, value)),
  onAddVendor: (data) => dispatch(addVendorToFilterAction(data.name)),
  onAddViewedStatus: (data) => dispatch(addViewedStatusToFilterAction(data.key)),
  onCalculateGST: (total, currency, taxRate) => dispatch(calculateGSTAction(total, currency, taxRate)),
  onChangeDocType: (accountId) => dispatch(changeDocumentTypeAction(accountId)),
  onChangeViewedSetting: (isViewed) => dispatch(submitChangeViewedSettingAction(isViewed)),
  onClearExportType: () => dispatch(clearExportTypeFilterAction()),
  onClearRefreshIntervals: () => dispatch(clearRefreshIntervalsAction()),
  onCreateCategory: (accountId, category) => dispatch(createCategoryAction(accountId, category)),
  onDeletePermanently: () => dispatch(deletePermanentlyAction()),
  onDeselectAllDocuments: () => dispatch(deselectAllDocumentsAction()),
  onEndBatchCategoriesMode: () => dispatch(endBatchCategoriesModeAction()),
  onEndBatchDownloadMode: () => dispatch(endBatchDownloadModeAction()),
  onEndBatchEditMode: () => dispatch(endBatchEditModeAction()),
  onEndHamburgerMode: () => dispatch(endHamburgerModeAction()),
  onEndDocViewerHamburgerMode: () => dispatch(endDocViewerHamburgerModeAction()),
  onEndDraggableMode: () => dispatch(endDraggabilityAction()),
  onEndExportMode: () => dispatch(endExportModeAction()),
  onEndFiltersDrawerMode: () => dispatch(endFiltersDrawerModeAction()),
  onEndMergeDocumentsMode: () => (dispatch(endMergeDocumentsModeAction())),
  onExitTrash: () => dispatch(setTrashViewAction(false)),
  onExportAll: (accountId) => dispatch(exportAllAction(accountId)),
  onExportSelected: (accountId, selectedDocumentIds) => dispatch(exportSelectedAction(accountId, selectedDocumentIds)),
  onGenerateShareUrl: (accountId, documentId) => dispatch(generateShareUrlAction(accountId, documentId)),
  onHideChangeDocType: () => dispatch(setChangeDocumentTypeVisibilityAction(false)),
  onHideDeletePermanently: () => dispatch(setDeletePermanentlyVisibilityAction(false)),
  onHideDocumentViewer: () => dispatch(setDocumentViewerVisibilityAction(false)),
  onHideEditColumns: () => dispatch(setEditColumnsVisibilityAction(false)),
  onHideGLCodesPanel: () => dispatch(hideGLCodesPanelAction()),
  onHideTrashMultipleDocuments: () => dispatch(setTrashMultipleDocumentsVisibilityAction(false)),
  onHideTrashDocument: () => dispatch(setTrashDocumentVisibilityAction(false)),
  onHideShareUrl: () => dispatch(setShareUrlVisibilityAction(false)),
  onLinkAccount: (slug) => dispatch(linkAccountAction(slug)),
  onOrderBy: (key) => dispatch(orderByAction(key)),
  onMapVendorRules: (accountId, documents) => dispatch(mapVendorRulesAction(accountId, documents)),
  onMergeDocuments: () => dispatch(mergeDocumentsAction()),
  onNextPage: () => dispatch(nextPageAction()),
  onPreviousPage: () => dispatch(previousPageAction()),
  onDocumentViewed: (data) => dispatch(documentViewedAction(data)),
  onRemoveCardNumber: (card) => dispatch(removeCardNumberFromFilterAction(card)),
  onRemoveCategory: (name) => dispatch(removeCategoryFromFilterAction(name)),
  onRemoveCurrency: (data) => dispatch(removeCurrencyFromFilterAction(data)),
  onRemoveDocumentType: () => dispatch(removeDocumentTypeFromFilterAction()),
  onRemoveEnvelope: (name) => dispatch(removeEnvelopeFromFilterAction(name)),
  onRemoveIncludeRule: (data) => dispatch(removeIncludeRuleAction(data)),
  onRemoveSearchQuery: () => dispatch(removeSearchQueryFromFilterAction()),
  onRemoveNameFromFilter: () => dispatch(removeNameFromFilterAction()),
  onRemovePaymentType: (name) => dispatch(removePaymentTypeFromFilterAction(name.toLowerCase())),
  onRemoveVendor: (name) => dispatch(removeVendorFromFilterAction(name)),
  onRemoveViewedStatus: () => dispatch(removeViewedStatusFromFilterAction()),
  onRestoreDocuments: () => dispatch(restoreDocumentsAction()),
  onReturnToDefaultColumns: () => dispatch(returnToDefaultColumnsAction()),
  onRowsDeselected: (ids) => dispatch(deselectDocumentsAction(ids)),
  onRowsSelected: (ids) => dispatch(selectDocumentsAction(ids)),
  onReprocessDocument: (accountId) => dispatch(reprocessDocumentAction(accountId)),
  onSaveDocument: () => dispatch(saveDocumentAction()),
  onSelectAllDocuments: (accountId, filters) => dispatch(selectAllDocumentsAction(accountId, filters)),
  onSelectMergeField: (field, data, id) => dispatch(selectMergeFieldAction(field, data, id)),
  onSetFlashMessage: (message) => dispatch(setFlashMessageAction(message)),
  onSetGlCode: (document, glCode) => dispatch(setGlCodeAction(document, glCode)),
  onSetGridWidth: (width) => dispatch(setGridWidthAction(width)),
  onSetViewedDocumentUrl: (url) => dispatch(setViewedDocumentUrlAction(url)),
  onShiftPressed: (e) => dispatch(shiftPressedAction(e)),
  onShiftReleased: (e) => dispatch(shiftReleasedAction(e)),
  onShowDocumentViewer: () => dispatch(setDocumentViewerVisibilityAction(true)),
  onShowGLCodesPanel: () => dispatch(showGLCodesPanelAction()),
  onStartBatchDownloadMode: () => dispatch(startBatchDownloadModeAction()),
  onStartExportMode: () => dispatch(startExportModeAction()),
  onStartFiltersDrawerMode: () => dispatch(startFiltersDrawerModeAction()),
  onUpdateSearchQuery: (query) => dispatch(updateSearchQueryAction(query)),
  onFocusDocument: (row, style) => dispatch(focusDocumentAction(row, style)),
  onSetExportType: (data) => dispatch(setExportTypeFilterAction(data.key)),
  onSetPaginationLimit: (limit) => dispatch(setPaginationLimitAction(limit)),
  onShowChangeDocType: () => dispatch(setChangeDocumentTypeVisibilityAction(true)),
  onShowDeletePermanently: () => dispatch(setDeletePermanentlyVisibilityAction(true)),
  onShowEditColumns: () => dispatch(setEditColumnsVisibilityAction(true)),
  onShowTrash: () => dispatch(setTrashViewAction(true)),
  onShowTrashMultipleDocuments: () => dispatch(setTrashMultipleDocumentsVisibilityAction(true)),
  onShowTrashDocument: () => dispatch(setTrashDocumentVisibilityAction(true)),
  onShowShareUrl: () => dispatch(setShareUrlVisibilityAction(true)),
  onStartBatchEditMode: () => dispatch(startBatchEditModeAction()),
  onStartBatchCategoriesMode: () => dispatch(startBatchCategoriesModeAction()),
  onStartDocViewerHamburgerMode: () => dispatch(startDocViewerHamburgerModeAction()),
  onStartHamburgerMode: () => dispatch(startHamburgerModeAction()),
  onStartDeleteCustomTabMode: (id) => dispatch(startDeleteCustomTabModeAction(id)),
  onStartDraggableMode: () => dispatch(startDraggabilityAction()),
  onStartMergeDocumentsMode: (documents, mergeDocumentId) =>
    (dispatch(startMergeDocumentsModeAction(documents, mergeDocumentId))),
  onStartRefreshIntervals: () => dispatch(startRefreshIntervalsAction()),
  onSubmitBatchAssignCategories: () => dispatch(submitBatchAssignCategoriesAction()),
  onSubmitBatchDownloadDocuments: () => dispatch(submitBatchDownloadDocumentsAction()),
  onSubmitBatchEdit: () => dispatch(submitBatchEditAction()),
  onToggleColumn: (key) => dispatch(toggleColumnAction(key)),
  onTrashMultipleDocuments: () => dispatch(trashMultipleDocumentsAction()),
  onTrashDocument: (accountId, document) => dispatch(trashDocumentAction(accountId, document)),
  onUnfocusDocument: () => dispatch(unfocusDocumentAction()),
  onSelectMergeDocument: (id) => dispatch(selectMergeDocumentAction(id)),
  onDeselectMergeDocument: () => dispatch(deselectMergeDocumentAction()),
  onUpdateDocument: (field, value) => dispatch(updateDocumentAction(field, value)),
  onUpdateInlineDocument: (data) => dispatch(updateInlineDocumentAction(data)),
  onUpdateName: (name) => dispatch(updateNameAction(name)),
  onUpdatePaymentType: (field, value) => dispatch(updatePaymentTypeAction(field, value)),
  onUpdateTotalFilter: (type, value) => dispatch(updateTotalFilterAction(type, value)),
  splitCategories: (categories) => dispatch(splitCategoriesAction(categories))
});

export const DocumentsContainer = connect(mapStateToProps, mapDispatchToProps)(DocumentsPage);



// WEBPACK FOOTER //
// ./src/js/containers/documents-container.jsx